module.exports = __webpack_public_path__ + "static/media/sls.81fe30c4.png";